// src/constants/tabs.js
export const TABS = [
    { key: "id", labelKey: "id_tab", aspect: "35/45" },
    { key: "custom", labelKey: "custom_tab", aspect: "50/50" },
];

export const TAB_DESCRIPTION = {
  id: {
    title: " ",
    description: "",
    link: "/id-requirements",
    image: "",
  },
  custom: {
    title: "",
    image: ""
  },
};
